import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import * as _ from 'lodash';

interface Loading {
  list: boolean;
  export: boolean;
  error: boolean;
}

interface Column {
  def: string;
  header: string;
}

@Component({
  selector: 'esc-report-viewer',
  templateUrl: './report-viewer.component.html',
  styleUrls: ['./report-viewer.component.scss']
})
export class ReportViewerComponent implements OnInit {
  @Input() columns: Column[];
  @Input() listData;
  @Input() listLength: number;
  @Input() loading: Loading;
  @Input() filterNumber: number;
  @Input() currentFilters;
  @Input() pageSizeOptions: number[];
  @Input() pageSize: number;
  @Input() page: number;
  @Input() moduleCode: string;

  @Output() onDownloadEvent = new EventEmitter();
  @Output() onOpenFilterEvent = new EventEmitter();
  @Output() onPageChangeEvent = new EventEmitter();
  @Output() onRefreshEvent = new EventEmitter();

  private prevPageSize = null;

  constructor(public media: MediaObserver) {}

  ngOnInit(): void {
    this.prevPageSize = this.pageSize;
  }

  get displayedColumns(): string[] {
    return this.columns.map((col) => col.def);
  }

  public downloadRequested() {
    this.onDownloadEvent.emit();
  }

  public openFilter() {
    this.onOpenFilterEvent.emit();
  }

  public changePage(event: { pageIndex: number; pageSize: number }) {
    if (this.prevPageSize !== event.pageSize) {
      if (event.pageSize > this.prevPageSize) {
        const computedPageIndex = Math.trunc(event.pageIndex / (event.pageSize / this.prevPageSize))
        event.pageIndex = computedPageIndex;
      }
    }

    if (event.pageIndex === 0) {
      event.pageIndex = 1;
    }

    this.prevPageSize = event.pageSize;
    this.onPageChangeEvent.emit(event);
  }

  public refresh() {
    this.onRefreshEvent.emit();
  }

  public isAnyLoading(): boolean {
    const loadingValues = Object.keys(this.loading)
      .filter((key) => key !== 'error') // Exclude 'error'
      .map((key) => this.loading[key]); // Get the corresponding values

    return loadingValues.some((value) => value);
  }
}
